import React, { useEffect, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import GeneralInfo from './GeneralInfo';
import ContactInfo from './ContactInfo';
import BankInfo from './BankInfo';
import BusinessInfo from './BusinessInfo';
import Integration from './Integration';
import Branding from './Branding';
import ViewBrandingImage from './ViewBrandingImage';
import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import CompanyInfo from './CompanyInfo';

const Profile = () => {
    const [profileInfo, setProfileInfo] = useState(null);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const merchantId = user?.data?.merchantId;

    const getProfileInfo = async () => {
        const response = await handleGetRequest(endPoints.getProfileInfo(merchantId), true);
        if (response) {
            setProfileInfo(response?.data);
        }
    };

    useEffect(() => {
        if (merchantId) {
            getProfileInfo();
        }
    }, []);

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Profile</h3>
            </div>
            <TabView>
                <TabPanel header="POC Info" leftIcon="pi pi-home mr-2">
                    <GeneralInfo profileInfo={profileInfo} />
                </TabPanel>
                {/* <TabPanel header="Contact Info" leftIcon="pi pi-phone mr-2">
                    <ContactInfo />
                </TabPanel> */}
                {/* <TabPanel header="Bank Details" leftIcon="pi pi-building mr-2">
                    <BankInfo />
                </TabPanel> */}
                <TabPanel header="Company Info" leftIcon="pi pi-info-circle mr-2">
                    <CompanyInfo profileInfo={profileInfo} />
                </TabPanel>
                {/* <TabPanel header="Business Info" leftIcon="pi pi-info-circle mr-2">
                    <BusinessInfo />
                </TabPanel> */}
                <TabPanel header="Integration" leftIcon="pi pi-cog mr-2">
                    <Integration />
                </TabPanel>
                <TabPanel header="Branding" leftIcon="pi pi-images mr-2">
                    <Branding />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default Profile;
